









import { Component, Vue, Prop } from 'vue-property-decorator';
import PrivacyPolicyApp from '@/privacy_policy/App.vue';

@Component({
  components: {
    PrivacyPolicyApp
  }
})
export default class Parts extends Vue {
  @Prop({ type: Number, required: true })
  public version!: number;
}
